module.exports = __webpack_public_path__ + "media/winner_single_line_1.c8931f2c.mp3";